<template>
    <div>
        <!-- Блок статистики -->
        <!-- <ColdClientStatistics /> -->
        
        <!-- Блок поиска и создания -->
        <ColdClientFinderAndCreator
            ref="coldClientFinderAndCreator"
            :key="componentRefreshKey"
            :isNeedCreate="isAdministrator ? true : false"
            :changed-item="changedItem"
            :additionalGetParameter="additionalGetParameter"
            typeOfTableFilter="cold-client"
            @universalEmit="handleUniversalEmit"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ColdClientFinderAndCreator from '@/components/coldClients/ColdClientFinderAndCreator.vue'
// import ColdClientStatistics from '@/components/coldClients/ColdClientStatistics.vue'

export default {
    name: 'ColdClients',
    components: {
        ColdClientFinderAndCreator,
        // ColdClientStatistics,
    },
    props: {
        changedItem: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            additionalGetParameter: '',
            componentRefreshKey: 0,
        }
    },
    computed: {
        ...mapGetters("auth", ["currentUser"]),

        isAdministrator() {
            return this.currentUser.role.includes('administrator');
        },
    },
    created() {
        this.additionalGetParameterChanger()
    },
    watch: {
        '$route.path'() {
            this.additionalGetParameterChanger()
        }
    },
    methods: {
        additionalGetParameterChanger() {
            // Здесь можно добавить логику для дополнительных параметров
            this.additionalGetParameter = ''
            this.componentRefreshKey += 1
        },
        
        handleUniversalEmit(eventName, ...params) {
            // Передаем событие дальше в ColdClientFinderAndCreator
            this.$refs.coldClientFinderAndCreator.universalEmit(eventName, ...params);
        },
    }
}
</script>
